import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchMCPServers,
  createMCPServer,
  updateMCPServer,
  deleteMCPServer,
  assignMCPServersToAdvisor,
  MCPServerCreateData,
  MCPServerUpdateData,
} from '@/api/mcpServer'
import {
  setLoading,
  setError,
  setServers,
  addServer,
  updateServer as updateServerAction,
  removeServer,
} from '@/redux/slices/mcpServerSlice'

export const fetchMCPServersThunk = createAsyncThunk(
  'mcpServer/fetchServers',
  async (roomId: string, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      const servers = await fetchMCPServers(roomId)
      dispatch(setServers(servers))
      return servers
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error || 'Failed to fetch MCP servers'
      dispatch(setError(errorMessage))
      throw error
    }
  }
)

export const createMCPServerThunk = createAsyncThunk(
  'mcpServer/createServer',
  async (
    { roomId, data }: { roomId: string; data: MCPServerCreateData },
    { dispatch }
  ) => {
    try {
      const server = await createMCPServer(roomId, data)
      dispatch(addServer(server))
      return server
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.name?.[0] ||
        'Failed to create MCP server'
      dispatch(setError(errorMessage))
      throw error
    }
  }
)

export const updateMCPServerThunk = createAsyncThunk(
  'mcpServer/updateServer',
  async (
    {
      roomId,
      serverId,
      data,
    }: { roomId: string; serverId: number; data: MCPServerUpdateData },
    { dispatch }
  ) => {
    try {
      const server = await updateMCPServer(roomId, serverId, data)
      dispatch(updateServerAction(server))
      return server
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.name?.[0] ||
        'Failed to update MCP server'
      dispatch(setError(errorMessage))
      throw error
    }
  }
)

export const deleteMCPServerThunk = createAsyncThunk(
  'mcpServer/deleteServer',
  async (
    { roomId, serverId }: { roomId: string; serverId: number },
    { dispatch }
  ) => {
    try {
      await deleteMCPServer(roomId, serverId)
      dispatch(removeServer(serverId))
      return serverId
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error || 'Failed to delete MCP server'
      dispatch(setError(errorMessage))
      throw error
    }
  }
)

export const assignMCPServersToAdvisorThunk = createAsyncThunk(
  'mcpServer/assignToAdvisor',
  async (
    { chatbotId, serverIds }: { chatbotId: string; serverIds: number[] },
    { dispatch }
  ) => {
    try {
      const result = await assignMCPServersToAdvisor(chatbotId, serverIds)
      return result
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error || 'Failed to assign MCP servers'
      dispatch(setError(errorMessage))
      throw error
    }
  }
)
